import {ARRANGEMENT_VIEW} from "constants/view-modes.js";
import {setShowArrangementTracks} from "actions/index.js";

export const addTag = (tag, tags, sequencerEngine) => {
    if (tag === '?') {
        // get a random sound 
        let c = sequencerEngine.ethereumCache;
        let fields = c.getAllForField('TAG', 0, 5000);
        let t = fields[Math.floor(Math.random() * fields.length)];
        sequencerEngine.searchForSounds([t.value]);
        return;
    }
    
    if (Array.isArray(tags)) {
        let r = Math.floor(Math.random() * tags.length);
        sequencerEngine.searchForSounds(tags[r]);
    } else {
        sequencerEngine.searchForSounds([tags]);
    }

    if (sequencerEngine.state.sequencer.viewMode === ARRANGEMENT_VIEW) {
        sequencerEngine.subSequences.forEach(
            ({id}) => sequencerEngine.dispatch(
                setShowArrangementTracks(
                    id, true)));

        let input = sequencerEngine.state.selector.searchInput;
        if (!input || !input.current || !input.current.focus) {
            return;
        }
        
        setTimeout(() => {
            input.current.focus();
        }, 100);
    }
};

